import React, { PropTypes, Component } from 'react';
import styled from 'styled-components';
import { NitroText, NitroIcon, NitroBadge } from 'nitro-components';

const Container = styled.div`
  display: flex;
  flex-direction: row; /* make main axis vertical */
  justify-content: ${props =>
    props.minimalHeading
      ? 'flex-end'
      : 'space-evenly'}; /* center items vertically, in this case */
  align-items: center;
  width: 100%;
  margin-left: ${props => props.left}px;
  margin-top: ${props => props.top}px;
`;

const StudContainers = styled.div`
  padding: ${props => (props.minimalHeading ? '0px 8px 4px 8px' : '8px 11px')};
  min-height: ${props => (props.minimalHeading ? 25 : 35)}px;
  min-width: 120px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
  justify-content: center; /* center items vertically, in this case */
  align-items: center;
  display: flex;
  margin-left: ${props => (props.minimalHeading ? '40px' : 'auto')};
  margin-right: ${props => (props.minimalHeading ? '0' : 'auto')};
  opacity: ${props => (props.disabled ? '0.50' : '0.93')};

  &:hover {
    opacity: ${props => (props.disabled ? '0.50' : '1')};
    scale: ${props => !props.disabled && '1.2'};
    cursor: ${props => !props.disabled && 'pointer'};
  }
`;

const StudContent = stud => (
  <div>
    {stud.icon && (
      <NitroIcon name={stud.icon} size={12} variant="white" right={12} />
    )}
    <NitroText size={12} variant="white" bold>
      {stud.label}
    </NitroText>
    {stud.count && (
      <NitroBadge
        label={stud.count}
        variant="white"
        bold
        size={10}
        right={5}
        textColor="secondary"
      />
    )}
  </div>
);

const HeaderStuds = props => (
  <Container
    top={props.top}
    left={props.left}
    minimalHeading={props.minimalHeading}
  >
    {props.studs.map((stud, index) => (
      <StudContainers
        dashboardType={props.dashboardType}
        key={index}
        minimalHeading={props.minimalHeading}
        disabled={stud.disabled}
        onClick={() => {
          if (!stud.disabled) {
            props.onStudClick(stud.type);
          }
        }}
      >
        {StudContent(stud)}
      </StudContainers>
    ))}
  </Container>
);

HeaderStuds.propTypes = {
  studs: PropTypes.array,
  top: PropTypes.number,
  left: PropTypes.number,
  minimalHeading: PropTypes.bool,
  onStudClick: PropTypes.func
};

HeaderStuds.defaultProps = {
  top: 0,
  left: 0,
  minimalHeading: false
};

export default HeaderStuds;



// WEBPACK FOOTER //
// ./src/features/dashboard/components/HeaderStuds.js